class Countdown extends HTMLElement {
	constructor() {
		super();
		this.userDate = this.getAttribute("data-date");
		this.userTime = this.getAttribute("data-time");
		this.interval;
		this.setInterval(this.userDate, this.userTime);
		this.initSection();
	}

	onInit(userDate, userTime) {
		this.completedCountdown = this.getAttribute("data-completed");
		this.countdown = this.querySelector(".countdown__main");
		this.countdownHeading = this.querySelector(".countdown__end-info");
		this.daysEl = this.querySelector(".countdown_block_days");
		this.hoursEl = this.querySelector(".countdown_block_hours");
		this.minutesEl = this.querySelector(".countdown_block_minutes");
		this.secondsEl = this.querySelector(".countdown_block_seconds");
		this.section = this.closest(".countdown-section");
		// ----------------------------------------------------------------
		const countdownDate = new Date(`${userDate}T${userTime}`);
		const now = new Date();
		const distance = countdownDate.getTime() - now.getTime();
		const days = Math.floor(distance / (1000 * 60 * 60 * 24));
		const hours = Math.floor(
			(distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60),
		);
		const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
		const seconds = Math.floor((distance % (1000 * 60)) / 1000);
		// ----------------------------------------------------------------
		if (distance < 0 && this.completedCountdown === "hide_section") {
			clearInterval(this.interval);
			this.section.style.display = "none";
		} else if (distance < 0 && this.completedCountdown === "show_text") {
			this.countdown.style.display = "none";
			this.countdownHeading.style.display = "flex";
		} else {
			// Clamp at zero once the countdown has ended so any instance without
			// a data-completed handler (e.g. the announcement-bar chips, which
			// render no data-completed attribute) never shows negative units.
			this.daysEl.textContent = Math.max(days, 0);
			this.hoursEl.textContent = Math.max(hours, 0);
			this.minutesEl.textContent = Math.max(minutes, 0);
			this.secondsEl.textContent = Math.max(seconds, 0);
		}
	}

	setInterval(userDate, userTime) {
		clearInterval(this.interval);
		this.interval = setInterval(
			this.onInit.bind(this, userDate, userTime),
			1000,
		);
	}

	playVideo(section) {
		const video = section.querySelector("video");

		if (video) {
			video.play();
		}
	}

	stopVideo(section) {
		const video = section.querySelector("video");

		if (video) {
			video.pause();
		}
	}

	initSection() {
		const sections = document.querySelectorAll(".countdown-section");

		const sectionObserver = new IntersectionObserver((entries) => {
			entries.forEach((entry) => {
				if (entry.isIntersecting) this.playVideo(entry.target);
				else this.stopVideo(entry.target);
			});
		});

		const sectionResizeObserver = new ResizeObserver((entries) => {
			const [entry] = entries;
			this.playVideo(entry.target);
		});

		sections.forEach((section) => {
			sectionObserver.observe(section);
			sectionResizeObserver.observe(section);
			this.drawMarkerLines(section);
		});
	}

	drawMarkerLines(section) {
		const markers = section.querySelectorAll('.countdown__marker');
		const products = section.querySelectorAll('.countdown__block--product');
		
		if (markers.length === 0 || products.length === 0) return;
		
		markers.forEach((marker, index) => {
			// Match marker index with product index (first marker with first product, etc.)
			const product = products[index];
			if (!product) return;
			
			const line = marker.querySelector('.countdown__marker-line');
			if (!line) return;
			
			const horizontalLine = line.querySelector('.countdown__marker-line-horizontal');
			const verticalLine = line.querySelector('.countdown__marker-line-vertical');
			
			if (!horizontalLine || !verticalLine) return;
			
			const updateLine = () => {
				// Check if product is hidden on mobile
				const isMobile = window.innerWidth <= 989;
				const isProductHidden = product.classList.contains('hidden-mobile');
				
				if (isMobile && isProductHidden) {
					// Hide marker and line on mobile if product is hidden
					marker.style.display = 'none';
					line.style.visibility = 'hidden';
					return;
				}
				
				// Always show marker on desktop, or on mobile if product is not hidden
				marker.style.display = '';
				
				// Get positions using offsetLeft/offsetTop for more reliable positioning
				const markerX = marker.offsetLeft + marker.offsetWidth / 2;
				const markerY = marker.offsetTop + marker.offsetHeight / 2;
				const productX = product.offsetLeft + product.offsetWidth / 2;
				const productY = product.offsetTop + product.offsetHeight / 2;
				
				// Calculate horizontal and vertical distances
				const horizontalDistance = productX - markerX;
				const verticalDistance = productY - markerY;
				
				// Check if line should go vertical first (above hypotenuse)
				const goesVerticalFirst = marker.getAttribute('data-line-vertical-first') === 'true';
				
				// Position line container at marker center
				const markerCenterX = (marker.offsetWidth / 2) - 10;
				const markerCenterY = (marker.offsetHeight / 2) - 10;
				
				line.style.left = markerCenterX + 'px';
				line.style.top = markerCenterY + 'px';
				line.style.visibility = 'visible';
				
				if (goesVerticalFirst) {
					// Draw vertical line first (above hypotenuse)
					if (Math.abs(verticalDistance) > 0) {
						verticalLine.style.width = '2px';
						verticalLine.style.height = Math.abs(verticalDistance) + 'px';
						verticalLine.style.left = '0';
						verticalLine.style.top = verticalDistance < 0 ? verticalDistance + 'px' : '0';
						verticalLine.style.visibility = 'visible';
					} else {
						verticalLine.style.visibility = 'hidden';
						verticalLine.style.height = '0';
					}
					
					// Draw horizontal line (90-degree turn at end of vertical line)
					if (Math.abs(horizontalDistance) > 0) {
						horizontalLine.style.width = Math.abs(horizontalDistance) + 'px';
						horizontalLine.style.height = '2px';
						// Position horizontal line at the end of vertical line
						horizontalLine.style.left = horizontalDistance < 0 ? horizontalDistance + 'px' : '0';
						horizontalLine.style.top = verticalDistance + 'px';
						horizontalLine.style.visibility = 'visible';
					} else {
						horizontalLine.style.visibility = 'hidden';
						horizontalLine.style.width = '0';
					}
				} else {
					// Draw horizontal line first (below hypotenuse - default)
					if (Math.abs(horizontalDistance) > 0) {
						horizontalLine.style.width = Math.abs(horizontalDistance) + 'px';
						horizontalLine.style.height = '2px';
						horizontalLine.style.left = horizontalDistance < 0 ? horizontalDistance + 'px' : '0';
						horizontalLine.style.top = '0';
						horizontalLine.style.visibility = 'visible';
					} else {
						horizontalLine.style.visibility = 'hidden';
						horizontalLine.style.width = '0';
					}
					
					// Draw vertical line (90-degree turn at end of horizontal line)
					if (Math.abs(verticalDistance) > 0) {
						verticalLine.style.width = '2px';
						verticalLine.style.height = Math.abs(verticalDistance) + 'px';
						// Position vertical line at the end of horizontal line
						verticalLine.style.left = horizontalDistance + 'px';
						verticalLine.style.top = verticalDistance < 0 ? verticalDistance + 'px' : '0';
						verticalLine.style.visibility = 'visible';
					} else {
						verticalLine.style.visibility = 'hidden';
						verticalLine.style.height = '0';
					}
				}
			};
			
			updateLine();
			
			const resizeObserver = new ResizeObserver(() => {
				updateLine();
			});
			
			resizeObserver.observe(section);
			resizeObserver.observe(marker);
			resizeObserver.observe(product);
			
			window.addEventListener('resize', updateLine);
		});
	}
}

customElements.define("countdown-timer", Countdown);
